var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "<Compound Path>",
    d: "M5.989 16 5.022 4.073h2l.924 10.489h6.11l.906-10.489h1.985L16.038 16zm8.066-16v1.8H18v1.435H4V1.8h3.945V0zm-3.63 14.563-.473-10.49H8.569l.557 10.489zm2.407 0 .568-10.49h-1.466l-.34 10.489z",
    transform: "translate(-3)",
    style: {
      fill: "#008da9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 65",
    style: {
      fill: "none",
      opacity: 0.512
    },
    d: "M0 0h16v16H0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconGreen);
export default __webpack_public_path__ + "static/media/trash-icon-green.a4155d74597d8aa446fe4a4feb3b20db.svg";
export { ForwardRef as ReactComponent };